
import { Vue, Prop, Component, State } from 'nuxt-property-decorator';
import type { PropType } from 'vue';
import Link from '@/components/ui/toc/links/Link';
import SiteMapLinkUtils from '@/components/ui/sitemap/SiteMapLinkUtils.vue';
import { PageContentInfo, PageTreeData } from '@/types/initialData';
import SiteMapTooltip from '@/components/ui/sitemap/SiteMapTooltip.vue';

@Component({
  name: 'SiteMapTreeItem',
  components: { SiteMapTooltip, SiteMapLinkUtils }
})
export default class SiteMapTreeItem extends Vue {
  // @ts-ignore
  @State((state) => state.typo3?.initial?.pagetreedata)
  pageTreeData: PageTreeData;

  @Prop({
    type: Object as PropType<Link>,
    required: true
  })
  link: Link;

  get pageContentInfo(): PageContentInfo {
    const pageData: PageContentInfo =
      this.pageTreeData && this.link.uid in this.pageTreeData
        ? this.pageTreeData[this.link.uid]
        : null;
    if (pageData !== null) {
      return {
        pbookPage: pageData?.pbookPage ?? 0,
        chapter: pageData?.chapter ?? 0,
        characters: pageData?.characters ?? 0,
        images: pageData?.images ?? 0,
        interactiveElements: pageData?.interactiveElements ?? 0,
        math: pageData?.math ?? 0,
        ogStandardPage: pageData?.ogStandardPage ?? 0,
        originalMaterial: pageData?.originalMaterial ?? 0,
        quizzes: pageData?.quizzes ?? 0,
        soundFiles: pageData?.soundFiles ?? 0,
        standardPage: pageData?.standardPage ?? 0,
        videos: pageData?.videos ?? 0,
        words: pageData?.words ?? 0,
        iPages: pageData?.iPages ?? 0,
        chapterInfo: pageData?.chapterInfo
      };
    }
    return null;
  }

  get hasChildren() {
    return this.link.children && this.link.children.length > 0;
  }

  get linkIsOnlyForTeachers(): boolean {
    return [2, 21].includes(Number(this.link.fe_group));
  }

  shortLinkForm(link: string): string {
    return `p${link}`;
  }
}
